import * as v from "valibot";
import { defineValidation } from "../../common/validation.common";

export const RadiusProfileCommonSchema = {
    create: v.object({
        mikrotikProfile: v.optional(v.string()),
        uploadSpeed: v.optional(v.number()),
        downloadSpeed: v.optional(v.number()),
        useBurst: v.boolean(),
        uploadBurstLimit: v.optional(v.number()),
        downloadBurstLimit: v.optional(v.number()),
        uploadBurstThreshold: v.optional(v.number()),
        downloadBurstThreshold: v.optional(v.number()),
        uploadBurstTime: v.optional(v.number()),
        downloadBurstTime: v.optional(v.number()),
        priority: v.optional(v.number()),
        uploadLimitAt: v.optional(v.number()),
        downloadLimitAt: v.optional(v.number()),
    }),
};

export namespace RadiusProfileValidation {
    export const Create = defineValidation(
        v.object({
            name: v.string(),
            notes: v.optional(v.string()),
            ...RadiusProfileCommonSchema.create.entries,
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.optional(v.string()),
            notes: v.optional(v.string()),
            ...RadiusProfileCommonSchema.create.entries,
        }),
    );
}
